// extracted by css-extract-rspack-plugin
export default {"input-wrapper":"ModerationReasonsList-module__input-wrapper--EcQuQ","inputWrapper":"ModerationReasonsList-module__input-wrapper--EcQuQ"};